import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import { Typography } from "@mui/material";
import {
  SegmentedControlContainer,
  SegmentedControlButton,
} from "../../../styled/pos/windows11";
import { setOrderType, setShowAddressForm } from "../../../../store/actions/newOrderSlice";

/**
 * CompactOrderTypeSelector - Segmented control for order type selection
 *
 * Options:
 * - DELIVERY (truck icon) - Opens address form if no address set
 * - TAKEOUT (bag icon)
 *
 * Design: Windows 11 segmented control pattern
 */
const CompactOrderTypeSelector = ({ iconOnly }) => {
  const dispatch = useDispatch();
  const orderType = useSelector((state) => state.newOrder.orderType);
  const address = useSelector((state) => state.newOrder.address);

  const handleSelectType = (type) => {
    dispatch(setOrderType(type));

    // If DELIVERY selected and no address, open address form
    if (type === "DELIVERY" && !address) {
      dispatch(setShowAddressForm(true));
    }
  };

  return (
    <SegmentedControlContainer>
      <SegmentedControlButton
        selected={orderType === "DELIVERY"}
        onClick={() => handleSelectType("DELIVERY")}
        aria-label="Selecionar entrega"
      >
        <LocalShippingIcon />
        {!iconOnly && (
          <Typography variant="body2" component="span">
            Entrega
          </Typography>
        )}
      </SegmentedControlButton>

      <SegmentedControlButton
        selected={orderType === "TAKEOUT"}
        onClick={() => handleSelectType("TAKEOUT")}
        aria-label="Selecionar retirada"
      >
        <TakeoutDiningIcon />
        {!iconOnly && (
          <Typography variant="body2" component="span">
            Retirada
          </Typography>
        )}
      </SegmentedControlButton>
    </SegmentedControlContainer>
  );
};

export default CompactOrderTypeSelector;
